import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ApplicationContext } from '../App'
import AdjudicateClaim from '../components/AdjudicateClaim'
import { ClaimDetails } from '../components/ClaimDetails'
import { ClaimHistory } from '../components/ClaimHistory'
import { ClaimPayments } from '../components/ClaimPayments'
import { ClaimServices } from '../components/ClaimServices'
import { ClaimSummary } from '../components/ClaimSummary'
import { getClaimByNumber } from '../services/claimsService'
import { GetClaimResponse } from '../services/models/claims'

interface ClaimData extends GetClaimResponse {
    status: 'Paid' | 'Submitted'
}

interface ClaimProps {
    view: 'summary' | 'details' | 'payments' | 'services' | 'history'
}

export const Claim = ({ view }: ClaimProps) => {
    const navigate = useNavigate()
    const { claimNumber } = useParams<{ claimNumber: string }>()
    const section =
        view === 'summary'
            ? 0
            : view === 'details'
            ? 1
            : view === 'payments'
            ? 2
            : view === 'services'
            ? 3
            : view === 'history'
            ? 4
            : 5
    // TODO: claim entry type

    const [data, setData] = useState<ClaimData>()
    const [nonce, setNonce] = useState(0)
    const lastUpdate = useContext(ApplicationContext)?.lastUpdate

    useEffect(() => {
        Promise.all([getClaimByNumber(claimNumber ?? '')])
            .then(async ([response]) => {
                const _data = await response.data
                setData({ ..._data, status: 'Submitted' })
            })
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch((err: Error) => {
                // TO DO
            })
    }, [claimNumber, lastUpdate, nonce])

    if (claimNumber === undefined || data === undefined) {
        return <></>
    }

    const getStatus = () => {
        if (data !== undefined && data?.remittance !== null) {
            // eslint-disable-next-line no-unsafe-optional-chaining
            for (const remittance of data?.remittance?.publicData?.payments) {
                if (remittance.patientControlNumber === claimNumber) {
                    data.status = 'Paid'
                    return 'Paid'
                }
            }
        }
        data.status = 'Submitted'
        return 'Submitted'
    }

    const getTab = (value: number) => {
        return value === 0
            ? 'summary'
            : value === 1
            ? 'details'
            : value === 2
            ? 'payments'
            : value === 3
            ? 'services'
            : value === 4
            ? 'history'
            : 'summary'
    }
    return (
        <Grid container direction="column" style={{ padding: '40px' }}>
            <Grid item>
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography variant="h3">Claim #{claimNumber}</Typography>
                    <Typography variant="h6" style={{ padding: '30px' }}>
                        {data.claim?.publicData.admissionTypeCode ? 'Facility' : 'Physician'}
                    </Typography>
                    <Typography
                        variant="h6"
                        style={{
                            padding: '4px 8px 4px 8px',
                            display: 'inline-block',
                            fontSize: '14px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            backgroundColor: '#C2E0F7',
                        }}
                    >
                        {getStatus()}
                    </Typography>
                    <AdjudicateClaim
                        claimNumber={claimNumber}
                        data={data}
                        // TODO: Refactor this
                        onUpdate={() => setNonce(Math.random())}
                    />
                </Box>
            </Grid>
            {((data.claim !== undefined && data.claim.privateData === undefined) ||
                (data.remittance !== null && data.remittance.privateData === undefined)) && (
                <Box
                    style={{
                        marginTop: '30px',
                        backgroundColor: '#C2E0F7',
                        borderRadius: '5px',
                        padding: '12px',
                    }}
                >
                    <Typography>You have limited access to this claim</Typography>
                </Box>
            )}
            <Grid item>
                <Box sx={{ marginTop: '30px', borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={section}
                        onChange={(_event, value) =>
                            navigate(`/claims/${claimNumber}/${getTab(value)}`)
                        }
                        aria-label="basic tabs example"
                    >
                        <Tab label="Summary" />
                        <Tab label="Details" />
                        <Tab label="Payments" />
                        <Tab label="Service Lines" />
                        <Tab label="History" />
                    </Tabs>
                </Box>
            </Grid>
            <Grid item>
                <Box style={{ marginTop: '30px' }}>
                    {section === 0 && <ClaimSummary data={data} claimNumber={claimNumber} />}
                    {section === 1 && <ClaimDetails data={data} />}
                    {section === 2 && <ClaimPayments data={data} />}
                    {section === 3 && <ClaimServices data={data} />}
                    {section === 4 && <ClaimHistory data={data} claimNumber={claimNumber} />}
                </Box>
            </Grid>
        </Grid>
    )
}
